var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-area"},[_c('div',{staticClass:"c-select",class:{
      up_down_icon: _vm.up_down_icon,
      learge: _vm.learge,
      middle: _vm.middle,
    }},[_c('select',{staticClass:"c-select__item",class:{round: _vm.round},attrs:{"name":"","id":""}},[_c('option',{attrs:{"value":""}},[_vm._v("下限なし")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("3")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }